import { reportError } from "../../lib/bugReporting";
import {
  CardActivationScriptName,
  Script,
  ScriptDetails,
  ScriptType,
} from "../../lib/api/models";
import { centsToDollarString } from "../../lib/formatting";

const cardActivationScript0003 = (): Script[] => [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If you have not verified address, phone, email, grad date and permission to discuss, do so before proceeding with Card Activation.",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Verify Social Security number and Date of Birth if not already verified. If either of them are incorrect, click the Close button.",
      },
    ],
  },
];

const cardActivationScript0006 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "I am sorry, the account you have provided has been closed. Due to your account status, please hold on the line while I transfer you to an account specialist that can assist you.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Transfer call to Central Services - Extension 6750",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0007 = (creditLimitCents: number): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue: `Your Card is now active and you have a credit limit of ${centsToDollarString(creditLimitCents)}.  You can start using it just about everywhere-at supermarkets, car rentals, internet and catalog purchases-just about any emergency expense you can think of-just remember to sign your Card and remove the label before you put it in your wallet. It is great having you as a customer. Thank you, and if you have any future customer service questions, just call the number that is printed on the back of your credit card, 1-800-733-1732. Is there anything else I can help you with?`,
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0008 = (): Script[] => [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If the social security number on file has one digit wrong or two numbers transposed and the Mothers Maiden Name/ Password can be verified, change social security number (Assigned Reps Only).",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If the social security number has more than one digit incorrect, check to see if the original application is available via Image Center. If the imaged information is correct, change the social security number (Assigned Reps Only).",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If original application is unavailable via Image Center or not applicable to make change read script below.",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "We must confirm the accuracy of your security information. Our records show that we currently have a discrepancy with your social security number. Please mail or fax a copy of your Social Security Card, so we can update your account. Once we receive that documentation and update your account, we will also activate your card. Our mailing address is on the back of your card, or our fax number is 605-232-3056.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0009 = (): Script[] => [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Check to see if the original application is available via Image Center. If the imaged information is correct, change the date of birth. (Assigned Reps Only)",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If original application is unavailable via Image Center or not applicable to make change read script below.",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "We must confirm the accuracy of your security information. Our records show that we currently have a discrepancy with your date of birth. Please mail or fax to us a copy of your Drivers License or State ID, so we can update your account. Once we receive that documentation and update your account, we will also activate your card. Our mailing address is on the back of your card or our fax number is 605-232-3056.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0010 = (): Script[] => [
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Check to see if the original application is available via Image Center. If the imaged information is correct change the social security number and/or date of birth. (Assigned Reps Only).",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If original application is unavailable via Image Center or not applicable to make change read script below.",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "We must confirm the accuracy of your security information. Our records show that we currently have a discrepancy with your social security number and date of birth. Please mail or fax to us a copy of your Social Security Card and Drivers License or State ID so we can update your account. Once we receive that documentation we will update your account and also activate your card. Our mailing address is on the back of your card or our fax number is 605-232- 3056.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0012 = (creditLimitCents: number): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue: `Let me remind you that you have a Credit Line of ${centsToDollarString(creditLimitCents)}. That means when your card is activated, you can use your card to spend up to ${centsToDollarString(creditLimitCents)}. You don't HAVE TO use your card to buy anything, but if you do, you will get a Billing Statement each month that tells you exactly how much you have to pay back to the bank by the payment due date. Now, I'm going to transfer you to our activation line and if you have any questions after you hear that your card is activated, you can always call us back, toll-free, at the number printed on the back of your credit card, 1-800-733-1732. Please hold while I transfer you.`,
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Transfer call to NO PIN ACTIVATION",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0014 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "The card is already activated.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If you need to Activate the Card again, click the Activate button to complete the process. Or you can click the Close button to close the Card Activation page.",
      },
    ],
  },
];

const cardActivationScript0015 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "I am sorry this card cannot be activated. Did you receive a new credit card?",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Please submit a Call Result for this search and search for the new account.",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0016 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "Let me review your account.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Please review the reason the Auth Prohib is on the account and follow the normal procedures to remove the status or transfer the caller to the correct department to handle the call.",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "If you need to Transfer the customer:",
      },
    ],
  },
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "I need to transfer you to an account specialist, please hold.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0017 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "I am sorry I cannot activate this card because the account is closed. Would you like me to see if you are eligible to have your account reissued?",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Please review the account and follow the normal procedures to see if the account is eligible to be reissued.",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0018 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "Let me review your account.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Please research the account to see if the Authorization Flag can be removed. If the Authorization Flag can be removed, follow normal procedures to do so",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0019 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue:
      "I am sorry, the account you have provided has been closed. Due to your account status, please hold on the line while I transfer you to an account specialist that can assist you.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Transfer the call to the appropriate Collections Department",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to End",
      },
    ],
  },
];

const cardActivationScript0020 = (): Script[] => [
  {
    scriptType: ScriptType.Dialogue,
    dialogue: "Let me review your account.",
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Please review the account and follow the normal procedures to transfer the caller to a specialist to handle the call.",
      },
    ],
  },
  {
    scriptType: ScriptType.Instruction,
    instructions: [
      {
        text: "Click Close button to end process or Activate Card button if you have approval from a Specialist or Supervisor.",
      },
    ],
  },
];

export const getCardActivationScriptDetails = (
  scriptName: CardActivationScriptName | undefined,
  creditLimitCents: number,
): ScriptDetails | undefined => {
  if (!scriptName) {
    return undefined;
  }

  let scriptContent: Script[];
  switch (scriptName) {
    case "CA_0003":
      scriptContent = cardActivationScript0003();
      break;
    case "CA_0006":
      scriptContent = cardActivationScript0006();
      break;
    case "CA_0007":
      scriptContent = cardActivationScript0007(creditLimitCents);
      break;
    case "CA_0008":
      scriptContent = cardActivationScript0008();
      break;
    case "CA_0009":
      scriptContent = cardActivationScript0009();
      break;
    case "CA_0010":
      scriptContent = cardActivationScript0010();
      break;
    case "CA_0012":
      scriptContent = cardActivationScript0012(creditLimitCents);
      break;
    case "CA_0014":
      scriptContent = cardActivationScript0014();
      break;
    case "CA_0015":
      scriptContent = cardActivationScript0015();
      break;
    case "CA_0016":
      scriptContent = cardActivationScript0016();
      break;
    case "CA_0017":
      scriptContent = cardActivationScript0017();
      break;
    case "CA_0018":
      scriptContent = cardActivationScript0018();
      break;
    case "CA_0019":
      scriptContent = cardActivationScript0019();
      break;
    case "CA_0020":
      scriptContent = cardActivationScript0020();
      break;

    default:
      reportError(
        new Error(
          "Programmer Error: Could not find script associated with the provided scriptName",
          {
            cause: scriptName,
          },
        ),
      );
      scriptContent = [];
  }

  return {
    script: scriptContent,
    name: scriptName,
  };
};
